import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // console.log("connect::image-alternative-controller");

    // let parent = this.element.getAttribute("data-parent");

    // if (parent) {
    //   parent = document.querySelector(parent);
    // }
    // else {
    //   parent = this.element.parentNode;
    // }

    // let parentWidth = parent.innerWidth;

    if (this.element.offsetWidth > 600) {
      this.element.style.backgroundImage = `url(${this.element.getAttribute("data-big")})`;
    }
    else if (this.element.offsetHeight > 420) {
      this.element.style.backgroundImage = `url(${this.element.getAttribute("data-big-vertical")})`;
    }
  }
}
